import * as React from "react";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { titleLabels } from "../../Resource/Contents";
import { validationMessage } from "../../Resource/Validation";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Prospect } from "../../../../../../../Wrap/Models/Models/Customer/Prospect";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { GenderMap } from "../../../../../../Shared/Entities/Maps/GenderMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";

interface IClientDetailProps extends IProcessComponentProps {
    data: Prospect;
}

interface IClientDetailState {}

export class ClientDetail extends ProcessComponent<IClientDetailProps, IClientDetailState> {
    constructor(props: IClientDetailProps) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data && !this.props.data.Title) {
            this.props.onChange({ Title: TitleMap.getString(Title.Mr) });
        }
    }

    render() {
        const { data } = this.props;
        return (
            <>
                <SelectEditor
                    options={TitleMap.getArray()}
                    cssWrapper="control-size-180"
                    selected={data ? TitleMap.getEnum(data.Title) : Title.Mr}
                    label={titleLabels.titleLable}
                    getText={(option) => TitleMap.getString(option)}
                    onChange={(value) => this.props.onChange({ Title: TitleMap.getString(value) })}
                    required={validationMessage.titleValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.FirstName}
                    label={titleLabels.firstNameLabel}
                    onChange={(value) => this.props.onChange({ FirstName: value })}
                    required={validationMessage.firstNameValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.Surname}
                    label={titleLabels.surnameLabel}
                    onChange={(value) => this.props.onChange({ Surname: value })}
                    required={validationMessage.surnameValidation}
                />
                <DatePicker
                    label={"Date of birth"}
                    formGroupCssWrapper={"control-size-430"}
                    selected={JsonDateParser.toDateNoOffset(data.DateOfBirth)}
                    alwaysValidateOnUpdate={false}
                    atLeast={{
                        value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                        errorMessage: ContentDatePicker.CannotBeInThePast,
                    }}
                    atMost={{
                        value: new Date(),
                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                    }}
                    showYearDropdown={true}
                    onChange={(selectedDate) =>
                        this.props.onChange({ DateOfBirth: JsonDateParser.toJsonDate(selectedDate) })
                    }
                    todayButton={ContentDatePicker.Today}
                    isClearable={true}
                    dateFormat={ContentDatePicker.DateFormat}
                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                    required={validationMessage.dateOfBirthValidation}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={titleLabels.genderLabel}
                    options={GenderMap.getArray()}
                    getText={(option) => GenderMap.getString(option)}
                    onChange={(value) => {
                        this.props.onChange({ Gender: value });
                    }}
                    selected={data?.Gender}
                    required={validationMessage.genderValidation}
                />
                <hr className="mt-40 mb-20" />
            </>
        );
    }
}
